import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { BUTTON_MIN_WIDTH } from './constants';

type WrapperProps = {
  maxWidth?: number;
};

export const Wrapper = styled.div<WrapperProps>(
  props => css`
    display: flex;
    align-items: center;
    border-radius: 8px;
    ${props.maxWidth &&
      css`
        max-width: ${props.maxWidth}px;
      `}
  `
);

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
`;

type Labelprops = {
  order?: number;
  selected: boolean;
};

export const Label = styled.label<Labelprops>(
  props => css`
    cursor: pointer;
    margin-right: ${layout.spacing.xSmall};
    margin-top: ${layout.spacing.xSmall};
    padding: 6px 12px;
    transition: box-shadow 0.1s linear;
    box-shadow: 0 0 0 1px ${props.theme.colors.base200};
    border-radius: 8px;

    min-width: ${BUTTON_MIN_WIDTH}px;

    &:hover {
      background: ${props.theme.colors.base100};
    }

    &:focus:not(.focus-visible) {
      outline: none;
    }

    ${props.selected &&
      css`
        box-shadow: 0 0 0 2px ${props.theme.colors.yellove500};
        color: ${p => p.theme.text.primary};
        font-weight: 600;
      `};

    ${props.order &&
      css`
        order: ${props.order};
      `}
  `
);

export const Input = styled.input`
  display: none;
`;

export const Title = styled.span`
  text-transform: capitalize;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Subtitle = styled.span(
  props => css`
    font-size: ${layout.measurements.fontSizeSmall};
    color: ${props.theme.colors.base500};
    text-overflow: ellipsis;
    overflow: hidden;
  `
);
